module.exports = __webpack_public_path__ + "media/images/icon-next-calendar-232d49e72a16ee780c149e466aa2ed04.svg";